import { Button, styled } from '@/theme/index';

export const CheckboxQuestion = {
  screenId: 'BUMP-002-02',
  customAttribute: 'vehicle_search_reasons',
  answerSet: [
    'Check the value',
    'Check its history',
    'Check its specifications',
    'Monitor for updates',
    'Just curious',
    'None of the above',
  ],
};

export const NEGATIVES_OPTIONS_FOR_UNCHECK = [
  'None of the above',
  'Not sure',
  'Uncertain',
  'Undecided',
];

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: theme.spacing(3),
  margin: 'auto',
  flexWrap: 'wrap',
  width: 'max-content',
  marginBottom: theme.spacing(3),
  WebkitAlignItems: 'baseline',
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  width: '290px',
  margin: 'auto',
  display: 'flex',
  [theme.breakpoints.up('sm')]: {
    width: '170px',
  },
}));
